<template>
    <v-dialog
        v-model="dialog"
        width="550"
        v-if="value"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="datePeriod"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                :hide-details="true"
            ></v-text-field>
        </template>

        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="5"></v-col>
                    <v-col
                            cols="7"
                    >
                        <h5 class="text-center mb-0">{{datePeriod}}</h5>
                    </v-col>
                </v-row>
                <v-divider class="pt-1 pb-1"></v-divider>
                <v-row>
                    <v-col
                        cols="5"
                    >
                        <v-btn
                            text
                            block
                            small
                            class="mb-2"
                            @click="setToday()"
                        >
                            Сегодня
                        </v-btn>
                        <v-btn
                            text
                            block
                            small
                            class="mb-2"
                            @click="setYesterday()"
                        >
                            Вчера
                        </v-btn>
                        <v-btn
                            text
                            small
                            block
                            class="mb-2"
                            @click="setThisWeek()"
                        >
                            Эта неделя
                        </v-btn>
                        <v-btn
                            text
                            small
                            block
                            class="mb-2"
                            @click="setLastWeek()"
                        >
                            Предыдущая неделя
                        </v-btn>
                        <v-btn
                            text
                            small
                            block
                            class="mb-2"
                            @click="setThisMonth()"
                        >
                            Этот месяц
                        </v-btn>
                        <v-btn
                            text
                            small
                            block
                            class="mb-2"
                            @click="setLastMonth()"
                        >
                            Предыдущий месяц
                        </v-btn>
                        <v-btn
                            text
                            small
                            block
                            class="mb-2"
                            @click="setThisYear()"
                        >
                            Этот год
                        </v-btn>
                        <v-btn
                            text
                            small
                            block
                            class="mb-2"
                            @click="setLastYear()"
                        >
                            Предыдущий год
                        </v-btn>
                    </v-col>
                    <v-col
                        cols="7"
                    >
                        <v-date-picker
                            v-model="dates"
                            @input="handleInput"
                            no-title
                            color="green"
                            range
                            locale="ru-ru"
                            first-day-of-week="1"
                        ></v-date-picker>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    color="danger"
                    dark
                    @click="clear"
                >
                    Очистить
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                    color="grey"
                    dark
                    @click="dialog = false"
                >
                    Закрыть
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "rl-datepicker",
    computed: {
        datePeriod() {
            return !this.dates || this.dates.length === 0 ? 'Выберите даты' : this.formatDate(this.dates[0]) + (this.dates[1] ? ' - ' + this.formatDate(this.dates[1]) : '')
        }
    },
    props: {
        value: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            dialog: false,
            dates: this.value
        }
    },
    methods: {
        handleInput () {
            this.$emit('input', this.dates)
        },
        formatDate(value){
            return value ? this.moment(String(value)).format('DD.MM.YYYY') : ''
        },
        setToday(){
            this.dates = [
                this.moment().format('YYYY-MM-DD'),
                this.moment().format('YYYY-MM-DD')
            ]
            this.handleInput()
        },
        setYesterday(){
            this.dates = [
                this.moment().subtract(1, 'days').format('YYYY-MM-DD'),
                this.moment().subtract(1, 'days').format('YYYY-MM-DD')
            ]
            this.handleInput()
        },
        setThisWeek(){
            this.dates = [
                this.moment().startOf('isoWeek').format('YYYY-MM-DD'),
                this.moment().endOf('isoWeek').format('YYYY-MM-DD')
            ]
            this.handleInput()
        },
        setLastWeek(){
            let day = this.moment().subtract(1, 'week')
            this.dates = [
                day.startOf('isoWeek').format('YYYY-MM-DD'),
                day.endOf('isoWeek').format('YYYY-MM-DD')
            ]
            this.handleInput()
        },
        setThisMonth(){
            this.dates = [
                this.moment().startOf('month').format('YYYY-MM-DD'),
                this.moment().endOf('month').format('YYYY-MM-DD')
            ]
            this.handleInput()
        },
        setLastMonth(){
            let day = this.moment().subtract(1, 'month')
            this.dates = [
                day.startOf('month').format('YYYY-MM-DD'),
                day.endOf('month').format('YYYY-MM-DD')
            ]
            this.handleInput()
        },
        setThisYear(){
            this.dates = [
                this.moment().startOf('year').format('YYYY-MM-DD'),
                this.moment().endOf('year').format('YYYY-MM-DD')
            ]
            this.handleInput()
        },
        setLastYear(){
            let day = this.moment().subtract(1, 'year')
            this.dates = [
                day.startOf('year').format('YYYY-MM-DD'),
                day.endOf('year').format('YYYY-MM-DD')
            ]
            this.handleInput()
        },
        clear(){
            this.dates = []
            this.handleInput()
        }
    }
}
</script>

<style scoped>

</style>
